//*************************DO NOT MODIFY*************************************
//
//THESE FILES ARE AUTOGENERATED AND ANY MODIFICATIONS MADE HERE WILL BE LOST
//
//*************************DO NOT MODIFY*************************************



export interface IUnitTypeViewModel {
    id?: number;
    name?: string | null;
    maximumBoardCapacity?: number;
    systemTypeId?: number;
    referenceUnitTypeId?: number;
    maximumReaderCapacity?: number;
}

export class UnitTypeViewModel implements IUnitTypeViewModel {
    public id: number;
    public name: string | null;
    public maximumBoardCapacity: number;
    public systemTypeId: number;
    public referenceUnitTypeId: number;
    public maximumReaderCapacity: number;
}
